import { createAiFetsClient } from './aiFetsClient';
import { createApiClient } from './fetsClient';
import { createGetProject } from './student-requests-v2/getProject';
import { createGetPreInitResponse } from './student-requests-v2/getStudentPreInit';
import { createInitializeProgressTracking } from './student-requests/initializeProgressTracking';
import { createGetTrackingData } from './student-requests/getTrackingData';
import { createSetTrackingData } from './student-requests/setTrackingData';
import { createSetCompletionStatus } from './student-requests/setCompletionStatus';

export const createStudentClient = (backendUrl: string, provideFunc: () => Promise<string>) => {
  const apiClient = createApiClient(backendUrl, provideFunc);
  const aiFetsClient = createAiFetsClient(backendUrl, provideFunc);

  return {
    getPreInit: createGetPreInitResponse(aiFetsClient),
    getProject: createGetProject(aiFetsClient),
    initializeProgressTracking: createInitializeProgressTracking(apiClient),
    getTrackingData: createGetTrackingData(apiClient),
    setTrackingData: createSetTrackingData(apiClient),
    setCompletionStatus: createSetCompletionStatus(apiClient),
  } as const;
};

export type StudentApiClient = ReturnType<typeof createStudentClient>;
